import React, { useEffect, useContext } from 'react'
import { VStack, Heading, Text, Box, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../config/colorTokens'
import { motion, AnimatePresence } from 'framer-motion'
import Section from '../components/Section'
import Project from '../components/Projects/Project'
import { projects } from "../data/projects"
import Loader from '../components/Loader/Loader'
import loaderContext from '../context/loaderContext'
import SEOHead from "../components/SEOHead";
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionVStack = motion(VStack)
const MotionBox = motion(Box)

const Projects = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])
    return (
        <div>
            <SEOHead 
                title="Projects | Prasoon Soni"
                description="Explore innovative projects built by Prasoon Soni - From web applications to full stack solutions, discover creative problem-solving through technology."
                path="/projects"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                <Section id="projects">
                    <VStack align="stretch" spacing={4} p={4}>
                        <MotionBox variants={heroVariants}>
                            <VStack align="start" spacing={3} mb={4}>
                                <Heading w="full">Projects</Heading>
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    color={t.textSubtle}
                                    fontWeight="light"
                                    maxW="2xl"
                                >
                                    A curated collection of my digital craftsmanship.
                                </Text>
                                <Box
                                    h="2px"
                                    w="60px"
                                    bgGradient={t.accentGradient}
                                    borderRadius="full"
                                    mt={1}
                                />
                            </VStack>
                        </MotionBox>
                        <MotionVStack
                            align="stretch"
                            spacing={4}
                            variants={containerVariants}
                        >
                            {projects.map((project) => {
                                return (
                                    <Project
                                        key={project.id}
                                        name={project.title}
                                        tech={project.tech}
                                        description={project.subtitle}
                                        bg={project.color2}
                                        emoji={project.emoji}
                                        github={project.repo}
                                        website={project.link}
                                        variants={itemVariants}
                                    />
                                )
                            })}
                        </MotionVStack>
                    </VStack>
                </Section>
                </MotionVStack>}
            </AnimatePresence>
        </div >
    )
}

export default Projects
